<template>
  <x-page-container class="common-page-container multiple-tab-list-page toolbar-page-container">
    <template v-slot:header>
      <x-button-group :button-config="buttonConfig">
        <template v-for="(item) in buttonSlotArray" v-slot:[item.name]="scope">
          <slot :name="item.name" v-bind="scope"></slot>
        </template>
      </x-button-group>
      <vxe-toolbar v-for="item in tabConfig.list" :key="item.name" v-show="tabConfig.activeName === item.name" ref="vxeToolbar" class="page-header-toolbar" :custom="custom"></vxe-toolbar>
    </template>
    <template v-slot:sub>
      <div ref="sub">
        <slot name="subBeforeCondition"></slot>
        <x-condition ref="xCondition" :condition-config="conditionConfig" :drawer-config="realDrawerConfig" :drawer-flag="drawerFlag">
          <template v-for="(item) in conditionSlotArray" v-slot:[item.name]="scope">
            <slot :name="item.name" v-bind="scope"></slot>
          </template>
        </x-condition>
        <slot name="subAfterCondition"></slot>
      </div>
      <x-download-dialog ref="downloadDialog" :downloadApi="realDownloadApi"
                         :listDownloadApi="listDownloadApi"
                         :deleteDownloadApi="deleteDownloadApi"
                         :download-params="downloadParams"
                         :excel-config="excelConfig"
      ></x-download-dialog>
      <slot name="subSuffix"></slot>
    </template>
    <template v-slot:main>
      <el-tabs v-model="tabConfig.activeName" :type="tabConfig.type || 'card'"
               @tab-click="handleTabClick" class="flex-tabs">
        <el-tab-pane v-for="item in tabConfig.list" :key="item.name" :label="item.label"
                     :name="item.name" ref="tabPane">
          <template v-if="item.labelSlot" v-slot:label>
            <slot :name="item.labelSlot" v-bind="{item}"></slot>
          </template>
          <slot v-if="item.slot" :name="item.name" v-bind="{item}"></slot>
          <x-table
            v-else
            v-on="$listeners"
            v-bind="$attrs"
            :auto-resize="false"
            :id="item.realId"
            :column-cache="item.columnCache"
            ref="xTable"
            border
            resizable
            height="100%"
            :row-config="rowConfig"
            :seq-config="realSeqConfig"
            :sort-config="realSortConfig"
            :filter-config="realFilterConfig"
            :columns="item.columns"
            :scroll-y="{gt: 60}"
            :menu-config="realMenuConfig"
            :edit-config="realEditConfig"
            :show-footer="item.showFooter"
            :footer-method="item.footerMethod"
            @menu-click="handleMenuClick"
            :table-setting-config="tableSettingConfig"
            :handle-table-setting-update="handleTableSettingUpdate"
            :align="'center' || $attrs.align"
            :header-align="'center' || $attrs.headerAlign || $attrs['header-align']"
          >
          </x-table>
        </el-tab-pane>
      </el-tabs>
    </template>
    <template v-slot:footer>
      <x-page-footer class="page-footer-remark" v-if="pageFooterConfig" :page-footer-config="pageFooterConfig" size="mini" @dblclick="handlePageFooterDblclick"></x-page-footer>
      <x-page-footer class="x-page-footer-dynamic-statistics" v-if="realDynamicStatisticsConfig.enabled" :page-footer-config="dynamicStatisticsPageFooterConfig"></x-page-footer>
      <el-pagination
        v-if="realPageConfig.show"
        :small="realPageConfig.small"
        background
        @size-change="handleSizeChange"
        @current-change="handlePageCurrentChange"
        :current-page="currentPage"
        highlight-hover-row
        :page-size="pageSize"
        :page-sizes="pageConfig.pageSizes"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        style="text-align: right"
      ></el-pagination>
    </template>
  </x-page-container>
</template>

<script>
import multipleTabListPageMixin from './multiple-tab-list-page-mixin';
import XPageFooter from '@/component/x-page-footer/x-page-footer.vue';
import {enhanceColumns} from '../../util/componentUtil';
import resizeMixin from '../../mixin/resize-mixin';
export default {
  name: 'XMultipleTabListPage',
  mixins: [resizeMixin, multipleTabListPageMixin],
  components:{XPageFooter},
  props: {
    downloadApi: Function,
    clipConfig: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      tabPaneDownloadApi: null
    };
  },
  watch: {
    'tabConfig.activeName': {
      handler(val) {
        for (const item of this.tabConfig.list) {
          if (val === item.name) {
            this.tabPaneDownloadApi = item.downloadApi;
            break;
          }
        }
      },
      immediate: true
    }
  },
  computed: {
    realDownloadApi() {
      return this.tabPaneDownloadApi || this.downloadApi;
    }
  },
  created () {
    const tabConfig = this.tabConfig;
    // 完善列的信息
    for (const item of tabConfig.list) {
      enhanceColumns({columns: item.columns, sortable: this.columnSortable});
      if (!item.footerMethod) {
        item.footerMethod = ({columns}) => {
          // 普通分页
          const arr = [];
          for (let i = 0; i < columns.length; i++) {
            const column = columns[i];
            const field = column.field;
            if (i === 0) {
              arr.push('总计');
              continue;
            }
            if (item.summary && Object.prototype.hasOwnProperty.call(item.summary, field)) {
              arr.push(item.summary[field]);
            } else {
              arr.push(null);
            }
          }
          return [arr];
        }
      }
    }
    if (!Object.prototype.hasOwnProperty.call(tabConfig, 'activeName')) {
      this.$set(tabConfig, 'activeName', tabConfig.list[0].name);
    }
  },
  methods: {
    handleTabClick (tabPane) {
      // 动态统计清零
      this.dynamicStatistics = 0;
      this.$nextTick(() => {
        const xTable = this.getCurrentTableInstance();
        xTable.loadData([]);
        this.currentPage = 1;
        this.total = 0;
        xTable.recalculate(true);
        this.$emit('tab-click', tabPane);
      });
    }
  }
};
</script>
<style lang="scss">
</style>
